exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input-group-text {\n    padding: 0.275rem 0.75rem !important;\n}\n", ""]);

// exports
